import { Navigate } from "react-router-dom";
import ComingSoon from "../ComingSoon";
import { isCat15NeedsAttentionOpen } from "../../../config/config";

const NeedsAttention = () =>
  isCat15NeedsAttentionOpen ? (
    <ComingSoon title="Needs-Attention" />
  ) : (
    <Navigate to="/financed-emissions/dashboard" replace />
  );

export default NeedsAttention;
